module.exports = __webpack_public_path__ + "img/elo.07ef251d.svg";